import React from 'react';

import styles from './styles.css';

export const Spinner = () => <div className={styles.spinner} />;
